export default __webpack_public_path__ + "static/media/PokerRunMap.470ff040.pdf";